import { LoginForm } from '@/components/shared';

const Login = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default Login;
